import { map } from "rxjs/operators";
import "../../api/types.js";
import "immer";
import { UserActivitySummary } from "../../contract/pam.js";
import "moment-timezone";
import { getValueFromQueryFilter } from "../../utils/query.js";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import { EntityBaseGqlService } from "../../api/EntityBaseGqlService.js";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { UserActivitySummaryRequestBuilder } from "./requestBuilder.js";
class UserActivitySummaryServiceModel extends UserActivitySummary {
  uid;
}
class UserActivitySummaryService extends EntityBaseGqlService {
  constructor(client, messageLocalizer) {
    super(client, new UserActivitySummaryRequestBuilder(), messageLocalizer);
  }
  getErrorSeverity(_code) {
    return 0;
  }
  get(requestPayload) {
    return super.fetchData(requestPayload).pipe(
      map((gqlResponse) => {
        const item = gqlResponse?.responsePayload?.getUserActivitySummary;
        const response = {
          ...gqlResponse,
          requestPayload,
          responsePayload: item ? { items: [item], total: 1 } : { items: [], total: 0 }
        };
        const uid = getValueFromQueryFilter(requestPayload?.filter, "uid");
        const payload = response?.responsePayload;
        return payload?.items?.length ? {
          ...response,
          responsePayload: {
            items: payload?.items?.map((i) => ({
              ...i ?? {},
              uid
            })),
            total: payload?.total
          }
        } : response;
      })
    );
  }
}
export {
  UserActivitySummaryService,
  UserActivitySummaryServiceModel
};
//# sourceMappingURL=service.js.map
